<template>
  <div></div>
</template>

<script>
export default {
  name: 'AlipayForm'
}
</script>

<style scoped>

</style>
